import * as stylex from '@stylexjs/stylex';
import '@tokens/colors.stylex';
import { colors } from '@tokens/colors.stylex';
import '@tokens/spacing.stylex';
import { spacing } from '@tokens/spacing.stylex';
import '@tokens/motion.stylex';
import { motion } from '@tokens/motion.stylex';

// Ported 1:1 from the prototype `.app` grid shell.
export const styles = {
  shell: {
    k1xSpc: "xrvj5dj x131h156",
    kZKoxP: "x1dr59a3 x1roiz7s",
    kVQacm: "xb3r6kr x1hhue18",
    kWkggS: "x16vpd03",
    kmkexE: "xesk12p",
    $$css: true
  },
  gridFull: {
    kumcoG: "x1vw52xh",
    $$css: true
  },
  gridRail: {
    kumcoG: "x1wdtju6",
    $$css: true
  },
  gridDrawer: {
    kumcoG: "x1y6fwsi",
    $$css: true
  },
  main: {
    k1xSpc: "x78zum5",
    kXwgrk: "xdt5ytf",
    k7Eaqz: "xeuugli",
    kAzted: "x2lwn1j",
    $$css: true
  },
  content: {
    kUk6DE: "x98rzlu",
    kORKVm: "x1odjw0f x11eozvf",
    kmVPX3: "x10ososl xa3lfe6 x18ub2qc",
    $$css: true
  }
};